// Copyright © Veeam Software Group GmbH
/* eslint-disable */
// Autogenerated

export enum RestoreSessionResult {
    Success = 0,
    Warning = 1,
    Failed = 2
}
